import * as API from '../api'
import { generate_timestamp } from '../utils/timestamp'
import { openOrDownloadPdf, downloadFile } from '../utils/downloads'

export const FETCHING_AVAILABLE_REPORTS = 'FETCHING_AVAILABLE_REPORTS'
export const FETCH_AVAILABLE_REPORTS = 'FETCH_AVAILABLE_REPORTS'
export const FETCH_AVAILABLE_REPORTS_ERROR = 'FETCH_AVAILABLE_REPORTS_ERROR'
export const CHANGE_CURRENT_REPORT = 'CHANGE_CURRENT_REPORT'

export const FETCHING_REPORT_LIST = 'FETCHING_REPORT_LIST'
export const FETCH_REPORT_LIST = 'FETCH_REPORT_LIST'
export const FETCH_REPORT_LIST_ERROR = 'FETCH_REPORT_LIST_ERROR'

export const FETCHING_INVOICE_LIST = 'FETCHING_INVOICE_LIST'
export const FETCH_INVOICE_LIST = 'FETCH_INVOICE_LIST'

export const getAvailableReports = areaId => {
  return dispatch => {
    dispatch({
      type: FETCHING_AVAILABLE_REPORTS,
      value: true
    })

    return API.report
      .getAvailableReports(areaId)
      .then(response => {
        const { data: items } = response

        dispatch({
          type: FETCH_AVAILABLE_REPORTS,
          items
        })
      })
      .catch(error => {
        dispatch({
          type: FETCH_AVAILABLE_REPORTS_ERROR
        })
      })
  }
}

export const changeCurrentReport = report => {
  return dispatch => {
    dispatch({
      type: CHANGE_CURRENT_REPORT,
      report
    })
  }
}

export const fetchReportList = (areaId, month, year) => {
  return dispatch => {
    dispatch({
      type: FETCHING_REPORT_LIST,
      value: true
    })

    return API.report
      .getReportList(areaId, month, year)
      .then(response => {
        const { data } = response
        const { responsibles, data: items, last_update } = data
        items.map(item => {
          if (item.last_month_amount)
            item.last_month_amount_with_measure = `${item.last_month_amount.toLocaleString('pt-BR', { minimumFractionDigits: 5 })} ${item.product_measure_description ||
              ''}`
          if (item.month_amount)
            item.month_amount_with_measure = `${item.month_amount.toLocaleString('pt-BR', { minimumFractionDigits: 5 })} ${item.product_measure_description ||
              ''}`
          if (item.consumed_amount)
            item.consumed_amount_with_measure = `${(
              item.consumed_amount * -1
            ).toLocaleString('pt-BR', { minimumFractionDigits: 5 })} ${item.product_measure_description || ''}`
          if (item.final_amount)
            item.final_amount_with_measure = `${item.final_amount.toLocaleString('pt-BR', { minimumFractionDigits: 5 })} ${item.product_measure_description ||
              ''}`
        })
        return dispatch({
          type: FETCH_REPORT_LIST,
          areaResponsible: responsibles.area_responsible,
          businessUnitResponsible: responsibles.business_unit_responsible,
          items,
          last_update
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_REPORT_LIST_ERROR
        })
      })
  }
}

export const getInvoiceList = (areaId, productId, month, year) => {
  return API.report.getInvoiceList(areaId, productId, month, year).then(response => {
    return response.data
  })
}

export const responsibleApproveMonth = ({ areaId, year, month, type }) => {
  return dispatch => {
    dispatch({
      type: FETCHING_REPORT_LIST,
      value: true
    })
    return API.report.responsibleApproveMonth({ areaId, month, year, type }).then(response => {
      return dispatch(fetchReportList(areaId, month, year))
    })
  }
}

export const closeMonth = ({ areaId, year, month }) => {
  return dispatch => {
    dispatch({
      type: FETCHING_REPORT_LIST,
      value: true
    })
    return API.report.closeMonth({ areaId, year, month }).then(response => {
      
      return dispatch(fetchReportList(areaId, month, year), getAvailableReports(areaId))
    })
  }
}

export const openMonth = ({ areaId, year, month }) => {
  return dispatch => {
    dispatch({
      type: FETCHING_REPORT_LIST,
      value: true
    })
    return API.report.openMonth({ areaId, year, month }).then(response => {
      return dispatch(fetchReportList(areaId, month, year), getAvailableReports(areaId))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/report.js